import styled from 'styled-components'


const EmptyStyle = styled.div`

    &.account,&.search {
        width:100%;
           .not-found {
                 width: 50%;
                padding-top: 40%;
                  margin: 0 auto;
         }                
                
    }

    .not-found {
		width: 45%;
		padding-top: 33%;
		margin: 0 auto;
	}

	.not-found-text {
		text-align:center;
	}

    @media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeS}){

        &.account,&.search {
            .not-found {
                width: 100%;
                padding-top: 70%;
                margin: 20px auto;
            }
         }

         .not-found {
            width: 100%;
            padding-top: 70%;
            margin: 20px auto;
        }
    }

`

export default EmptyStyle